import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DxButtonComponent, DxLookupComponent } from 'devextreme-angular';
import { Dipendente } from 'src/app/models/dipendente';

@Component({
  selector: 'app-popup-scelta-dipendente',
  templateUrl: './popup-scelta-dipendente.component.html',
  styleUrls: ['./popup-scelta-dipendente.component.scss'],
  imports: [DxButtonComponent, DxLookupComponent],
  standalone: true,
})
export class PopupSceltaDipendenteComponent {
  @Input() listDipendenti: Dipendente[];
  @Output() idDipendenteEventEmitter = new EventEmitter<number>();

  idDipendente:number;

  onScegliDipendente(){
    this.idDipendenteEventEmitter.emit(this.idDipendente);
  }
  onAnnullaDipendente(){
    this.idDipendenteEventEmitter.emit(null);
  }

  displayDipendente(item){
    if(item==undefined){
        return '';
    }
    return item.codice + "-" + item.nominativo;
  }
}
